<template>
    <div class="missing-samples-container"
         @mouseenter="batchMouseEnter"
         @mouseleave="batchMouseLeave"
         @click="handleBatchClickHandler"
         v-if="isVisible">
        <div class="title-wrapper">
            <div class="title-left">
                <span class="title">Missing samples</span>
                <span class="toggle" v-show="showToggle"><i class="fas fa-caret-down fa-2x"></i></span>
                <div class="details"><span>missing count: {{missingSamplesCount}}, last missing samples: {{lastMissingItems}}</span>
                </div>
            </div>
            <div class="title-right">
                <div class="warning-sign">
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
            </div>
        </div>
        <div class="toggle text-right"></div>
        <div class="samples-wrapper" v-if="detailsMode" @click.stop="">
            <v-divider class="mt-2 mb-2"></v-divider>
            <missing-samples-list :missing-samples="missingSamples"></missing-samples-list>
        </div>
    </div>

</template>

<script>
    import _ from 'lodash'
    import {mapGetters, mapState} from 'vuex'
    import MissingSamplesList from './MissingSamplesList'
    export default {
        name: "MissingSamplesContainer",
        components: {
            MissingSamplesList
        },
        data() {
            return {
                active: false,
                detailsMode: false
            }
        },
        computed: {
            ...mapState('batches', {
                missingSamples: 'missingSamples'
            }),
            ...mapGetters('batches', {
                    progress: 'progress',
                }
            ),
            showToggle() {
                return this.active && !this.detailsMode
            },
            missingSamplesCount() {
                return _.get(this, 'missingSamples', []).length
            },
            lastMissingItems() {
                const sortedByCases = _.orderBy(this.missingSamples, ['caseSystemId'], ['desc'])
                const lastMissingItems = _.take(sortedByCases, 3)

                const result = _.map(lastMissingItems, (i) => {
                    return i.fullName
                })

                return _.join(result, ', ')
            },
            isVisible() {
                return this.missingSamplesCount > 0
            }
        },
        methods: {
            batchMouseEnter() {
                this.active = true
            },
            batchMouseLeave() {
                this.active = false
            },
            handleBatchClickHandler() {
                this.detailsMode = !this.detailsMode

                if (!this.detailsMode) {
                    return
                }
            },
        }
    }
</script>

<style scoped>
    .missing-samples-container {
        margin-top: 10px;
        margin-bottom: 10px;
        padding: 10px;
        border: 1px solid #cecece;
        border-radius: 5px;
    }

    .missing-samples-container:hover {
        border: 1px solid #acacac;
    }

    .title {
        font-size: 14px;
        color: #f53d3d;
    }

    .title-wrapper {
        position: relative;
        cursor: pointer;
    }

    .details {
        font-size: 10px;
        color: #545454;
    }

    .toggle {
        color: #acacac;
        opacity: 1;
        position: absolute;
        left: 50%;
        top: 54px;
    }

    .warning-sign {
        font-size: 32px;
        color: #f53d3d;
    }

    .title-left {
        display:inline-block;
    }

    .title-right {
        float: right;
        display: inline-block;
    }


</style>